<script lang="ts">
    import { unauthorized, authenticatedUser, serverEnv } from "../stores/AppStatus";

    import TopAppBar, { Row, Section } from "@smui/top-app-bar";
    import { _ } from "svelte-i18n";
    import HomeButton from "./header/HomeButton.svelte";
    import ActiveModuleTitle from "./header/ActiveModuleTitle.svelte";
    import AppTitle from "./header/AppTitle.svelte";
    import UserMenu from "./header/UserMenu.svelte";
    import ExchangeRatesBox from "./header/ExchangeRatesBox.svelte";
</script>

<TopAppBar variant="static" color="primary">
    <Row class="">
        <Section class="pa-0 ma-0">
            <HomeButton />
            <AppTitle />
            {#if $serverEnv && ['DEV','UAT'].includes($serverEnv) }
                    <div id="envMsg" class="mdc-top-app-bar__row left-splitter yellow-text fs-14 ma-0 pl-4 pr-4 pt-2 pb-2 mxw-10">
                        <span class="font-weight-bold">{$serverEnv}</span>
                        <span>{@html $_('test_env_msg')}</span>
                    </div>
            {/if}
            {#if !$unauthorized}
                <ActiveModuleTitle />
            {/if}
        </Section>
        <Section class="ma-0 pa-0" align="end" toolbar>
            {#if !$unauthorized}
                <!--<RoleBox />-->
                {#if !$authenticatedUser.isSupplier}
                    <ExchangeRatesBox />
                {/if}

                <UserMenu />
            {/if}
        </Section>
    </Row>
</TopAppBar>

<style>
    #envMsg {
        vertical-align: middle;
        display: flex;
        flex-direction: column;
        flex: 1;
        justify-content: center;
    }
 
</style>